import { memo } from 'react';

import { type Wws_Page } from '../../types/graphql';
import SinglePageContent from '../SinglePageComponents/SinglePageContent';
import { ActiveSinglePageSectionProvider } from '../../context/ActiveSinglePageSectionContext';
import { useNavLink } from '../../lib/useNavLinks';

export const getSectionId = (page: Wws_Page) => {
  if (page.routeName === '') {
    return 'home';
  }

  return page.routeName || '';
};

export const handleSinglePageSectionScrolling = (sectionId: string) => {
  if (sectionId === '' || sectionId === 'home') {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    return null;
  }

  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }

  return element;
};

export interface TemplateProps {
  themeOverride: string;
}

function SinglePageTemplate({ themeOverride }: TemplateProps) {
  const navLinkOverrides = {
    rsvpPageOverride: {
      routeName: 'rsvp-section',
    },
    registryPageOverride: {
      routeName: 'registry-section',
    },
  };
  const pages = useNavLink(navLinkOverrides) as Wws_Page[];

  return (
    <ActiveSinglePageSectionProvider pages={pages || []}>
      <SinglePageContent themeOverride={themeOverride} pages={pages} />
    </ActiveSinglePageSectionProvider>
  );
}

export default memo(SinglePageTemplate);
